import { render, staticRenderFns } from "./BannerPage.vue?vue&type=template&id=2c3833a2&scoped=true"
import script from "./BannerPage.vue?vue&type=script&lang=js"
export * from "./BannerPage.vue?vue&type=script&lang=js"
import style0 from "./BannerPage.vue?vue&type=style&index=0&id=2c3833a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3833a2",
  null
  
)

export default component.exports